import { render, staticRenderFns } from "./afiliado.vue?vue&type=template&id=7f70165c&"
import script from "./afiliado.vue?vue&type=script&lang=js&"
export * from "./afiliado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports